// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Yxt3","header":"ReportDetails_header__A3Sl0","title":"ReportDetails_title__1W0rg","left":"ReportDetails_left__djtid"};